import { lastValueFrom, Observable, take } from "rxjs";

export default abstract class ContentControlStudioOperation {
   constructor(
    public doFunction: () => void | Promise<void>,
    public undoFunction: () => void | Promise<void>,
    public callback?,
    public isSaved: boolean = false,

  ) {}

  async do(): Promise<void> {
    const result = this.doFunction();
    if (result instanceof Observable) {
      await lastValueFrom(result.pipe(take(1)));
    }
    if (this.callback) {
      this.callback();
    }
  }

  async undo(): Promise<void> {
    const result = this.undoFunction();
    if (result instanceof Observable) {
      await lastValueFrom(result.pipe(take(1)));
    }
    if (this.callback) {
      this.callback();
    }
  }
}
